<template>
  <div class="page-main">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Admin</li>
      </ol>
      <h1 class="page-title">Add-ons Cost</h1>
      <div class="page-header-actions">
        <div class="row no-space w-120">
          <div class="col-xs-12">
            <div class="counter">
              <div class="counter-label p-t-5">Total Add-ons</div>
              <span class="counter-number font-weight-medium">{{total_addon}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-content">
      <div class="panel">
        <div class="panel-body panel-form">
          <loading-indicator v-if="isLoading"></loading-indicator>
          <div v-else-if="isError">
          </div>
          <div v-else>
            <div class="p-b-15">
              <div class="row">
                <div class="col-xs-2 col-md-6">
                  <router-link v-bind:to="`/${$route.params.namespace}/admin/addon-cost/create`" class="btn btn-primary">
                    <i class="icon md-plus" aria-hidden="true"></i><span class="text hidden-sm-down"> Create </span>
                  </router-link>
                </div>
                <!--div class="col-xs-6 col-md-4 pull-xs-right">
                  <div class="form-group">
                    <v-select v-model="currentTeam" :options="filterItems" placeholder="Filter by Team"></v-select>
                  </div>
                </div-->
              </div>
            </div>
            <div class="table-striped table-hover table-responsive" v-if="addons.length > 0">
              <table class="table">
                <thead>
                  <tr>
                    <th class="cell-30">ID</th>
                    <th class="cell-300">Description</th>
                    <th class="cell-300">Team</th>
                    <th class="cell-100">Status</th>
                    <th class="cell-100">Type</th>
                    <th class="cell-200">Use on Billing Monthly</th>
                    <th class="cell-50"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in addons">
                    <td class="cell-30">{{item.id}}</td>
                    <td class="cell-300">{{item.description}}</td>
                    <td class="cell-300">
                      <router-link v-bind:to="`/${$route.params.namespace}/admin/teams/${item.team.namespace}/billings`">
                        {{item.team.namespace}}
                      </router-link>
                    </td>
                    <td class="cell-100 text-nowrap">
                      <span v-if="!item.is_deactivate" class="tag tag-success">Available</span>
                      <span v-else class="tag tag-danger">Deactivate</span>
                    </td>
                    <td class="cell-100">
                      <span v-if="item.type == 'recurring'">Recurring</span>
                      <span v-else>One Time</span>
                    </td>
                    <td class="cell-200">
                      <span>{{getDate(item.started_at)}}</span>
                      <span v-if="item.terminated_at">- {{getDate(item.terminated_at)}}</span>
                    </td>
                    <td class="cell-50 text-nowrap">
                      <button v-on:click.stop.prevent="changeItem(item, index)"
                        class="btn btn-sm btn-default"
                        alt="Deactivate" v-if="!item.is_deactivate">Deactive
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="alert alert-primary alert-dismissible" v-else>
              There is no Add-ons.
            </div>
          </div>
          <paginate
            v-show="(pagination.total_page > 1)"
            v-bind:pageCount="pagination.total_page"
            v-bind:prevText="'«'"
            v-bind:nextText="'»'"
            v-bind:clickHandler="changePage"
            v-bind:containerClass="'pagination pull-right'"
            v-bind:pageClass="'page-item'"
            v-bind:pageLinkClass="'page-link'"
            v-bind:prevClass="'page-item'"
            v-bind:prevLinkClass="'page-link'"
            v-bind:nextClass="'page-item'"
            v-bind:nextLinkClass="'page-link'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import LoadingIndicator from 'components/LoadingIndicator';
import swal from 'sweetalert2';
import vSelect from 'vue-select';

export default {
  components: {
    vSelect,
    LoadingIndicator,
  },
  data: function() {
    return {
      isLoading: false,
      isError: false,
      total_addon: 0,
      teams: [],
      currentTeam: null,
      addons: [],
      pagination: {
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 0,
        from: 1,
        to: 1,
        next_page_url: null,
        prev_page_url: null,
        total_page: 0,
      },
    };
  },
  created: function() {
    this.isLoading = true;
  },
  watch: {
    currentTeam: function(value) {
      if (value) {
        this.fetchAddons(value.value);
      }
    },
  },
  computed: {
    filterItems: function () {
      const temp = [];
      this.teams.forEach((item) => {
        temp.push({ label: item.namespace, value: item.namespace });
      });
      return temp;
    },
  },
  mounted: function() {
    this.fetchTeams();
    this.fetchAddons();
  },
  methods: {
    fetchTeams: function() {
      const url = `/api/teams?except=reseller`;

      axios.get(url)
      .then((response) => {
        this.teams = response.data.data;
        this.isLoading = false;
        this.isError = false;
      })
      .catch(() => {
        this.isLoading = false;
        this.isError = true;
      });
    },
    fetchAddons: function() {
      const url = `/api/admin/billaddons`;
      axios.get(url)
      .then((response) => {
        this.total_addon = response.data.total;
        this.makePagination(response.data);
        this.addons = response.data.data;
        this.isLoading = false;
        this.isError = false;
      })
      .catch(() => {
        this.isLoading = false;
        this.isError = true;
      });
    },
    makePagination: function(data) {
      this.pagination.total = data.total;
      this.pagination.per_page = data.per_page;
      this.pagination.current_page = data.current_page;
      this.pagination.last_page = data.last_page;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.next_page_url = data.next_page_url;
      this.pagination.prev_page_url = data.prev_page_url;
      this.pagination.total_page = Math.ceil(data.total / data.per_page);
    },
    getDate: function (date) {
      return moment(date, ['YYYY-MM', moment.ISO_8601]).format('MMM YYYY');
    },
    changePage: function(page) {
      this.fetchTeams(page);
    },
    changeItem: function(item, index) {
      const text = `Are you sure to deactivate Add-on ${item.description}`;
      swal({
        title: 'Are you sure to deactivate?',
        text: text,
        showCancelButton: true,
        confirmButtonColor: '#00A6ED',
        cancelButtonColor: '#c6d3d7',
        confirmButtonText: 'Yes, deactivate it',
        closeOnConfirm: true,
      }).then(() => {
        const url = `api/admin/billaddons/${item.id}/deactivate`;
        axios.post(url)
        .then((response) => {
          // repalce with new item that complate deactive
          this.addons.splice(index, 1, response.data);
          swal(
            'Success',
            'Add-on have been deactive',
            'success'
          );
        })
        .catch(() => {

        });
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// AddonCostBrowser.vue?465fd738